module.exports = __webpack_public_path__ + "static/media/f1.b94ee136.png";